import type SuperJSON from "superjson";
import type { Currency } from "./Amount";
import { Amount } from "./Amount";

/**
 * Register the SuperJSON transformer for Amount.
 * Pass the SuperJSON instance you want to register on (client or server instance).
 */
export function registerAmountTransformer(superjson: typeof SuperJSON): void {
  superjson.registerCustom<
    Amount,
    {
      amount: number;
      currency: Currency;
      precision: number;
    }
  >(
    {
      isApplicable: Amount.isAmount,
      serialize: Amount.serialise,
      deserialize: Amount.deserialise,
    },
    "Amount"
  );
}
